function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInfoInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.92,4.08a10.49,10.49,0,1,0,0,14.84A10.51,10.51,0,0,0,18.92,4.08Zm1.33,7.42A8.75,8.75,0,1,1,11.5,2.75,8.77,8.77,0,0,1,20.25,11.5Z",
    style: {
      fill: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.45,
    y: 9.98,
    width: 2.09,
    height: 6.77,
    rx: 1.05,
    style: {
      fill: "#8a8a8a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.47,
    cy: 7.44,
    r: 1.08,
    style: {
      fill: "#8a8a8a"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoInactive);
export default __webpack_public_path__ + "static/media/ic-info-inactive.6fb091bf419da6642929315ac799bf65.svg";
export { ForwardRef as ReactComponent };